/**
 * Configuration for localStorage keys that should be cleared when account switch occurs.
 *
 * These keys store account-specific data that should not persist across account switches.
 * Add keys to this array to ensure they are cleared when a user switches accounts.
 */
export const ACCOUNT_SWITCH_STORAGE_KEYS: readonly string[] = [
    // Certificate-related data
    "incomingZones",
    "exemptReasons",
    "invalidReasons",
    "allStates",
] as const;
